module.exports = __webpack_public_path__ + "72429294b4e676f57680c336ea8f1648.png";